// converts a string to base64 (url/filename safe variant)
export function stringToBase64Url(str: string) {
  var b64 = btoa(str);
  return base64ToBase64Url(b64);
}

// converts a standard base64-encoded string to a "url/filename safe" variant
export function base64ToBase64Url(b64: string) {
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

// converts a "url/filename safe" base64 string to a "standard" base64 string
export function base64UrlToBase64(b64u: string) {
  return b64u.replace(/-/g, '+').replace(/_/g, '/');
}

export function base64UrlToString(b64u: string) {
  var b64 = base64UrlToBase64(b64u);
  switch (b64.length % 4) {
    case 0:
      break;
    case 2:
      b64 += '==';
      break;
    case 3:
      b64 += '=';
      break;
    default:
      throw new Error('Not a valid Base64Url');
  }
  var utf8 = atob(b64);
  try {
    return decodeURIComponent(escape(utf8));
  } catch (e) {
    return utf8;
  }
}

export function stringToBuffer(str: string) {
  var buffer = new Uint8Array(str.length);
  for (var i = 0; i < str.length; i++) {
    buffer[i] = str.charCodeAt(i);
  }
  return buffer;
}

export function base64UrlDecode(str: string) {
  return atob(base64UrlToBase64(str));
}

// Converts base64 string to binary data view
export function base64UrlToBuffer(b64u: string) {
  return Uint8Array.from(base64UrlDecode(b64u), (c: string) => c.charCodeAt(0));
}

// Converts an ArrayBuffer object that contains binary data to base64 encoded string
export function bufferToBase64Url(bin: any) {
  return btoa(new Uint8Array(bin).reduce((s, byte) => s + String.fromCharCode(byte), ''));
}

 function dec2hex (dec: number) {
   return ('0' + dec.toString(16)).substr(-2);
 }

 function getRandomString(length: number) {
   var a = new Uint8Array(Math.ceil(length / 2));
   crypto.getRandomValues(a);
   var str = Array.from(a, dec2hex).join('');
   return str.slice(0, length);
 }

 function generateVerifier(prefix?: string): string {
   var verifier = prefix || '';
   if (verifier.length < 43) {
     verifier = verifier + getRandomString(43 - verifier.length);
   }
   return encodeURIComponent(verifier).slice(0, 128);
 }

 function computeChallenge(str: string): PromiseLike<any> {
   var buffer = new TextEncoder().encode(str);
   return crypto.subtle.digest('SHA-256', buffer).then(function(arrayBuffer) {
     var hash = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer) as unknown as number[]);
     var b64u = stringToBase64Url(hash); // url-safe base64 variant
     return b64u;
   });
 }

 export default {
   getRandomString,
   generateVerifier,
   computeChallenge
 };
